import React from "react";
import ProductDetail from "./ProductDetail";
import "../styles/ProductDetails.css"
import RelatedProduct from "./RelatedProduct";

function ProductDetails() {
  return (
    <>
      <ProductDetail />
      <RelatedProduct />
      
    </>
  );
}

export default ProductDetails;
